module.exports = __webpack_public_path__ + "static/media/prize-header.5a51b1a3.jpg";